export enum ResponseOnHold {
  INIT_ERROR = '-1',
  PAYMENT_ERROR = '2',
  HTTP_ERROR = '1',
  RESERVED_ERROR = '0',
}
